module.exports = __webpack_public_path__ + "media/service_features/number_01-51e9c92b.svg";